import React from "react";
import { listingStates } from "../../../../util/flStates";
import DashListings from "../DashListings/DashListings";

function DashRentListings({
  passedListings = [],
  accessToken,
  role,
  handleRestore,
}) {
  return (
    <DashListings
      passedListings={passedListings}
      accessToken={accessToken}
      listingType={listingStates.rent}
      handleRestore={handleRestore}
      role={role}
    />
  );
}

export default DashRentListings;
